import React from 'react';

const Home = () => {
    return (
        <div>
            <h1>Home Page</h1>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde eum blanditiis dignissimos necessitatibus delectus, quia cumque reprehenderit, non nihil illo dicta in laboriosam a neque nesciunt pariatur id officiis facilis.</p>
        </div>
    );
};

export default Home;